const ROLE = {
    ADMIN : "admin",
    USER : "user",
    // MANAGEBLOG : "manageblog",
    // MANAGESALES : "managesales",
}

export default ROLE